import orderStatuses from '@/helpers/orderStatuses'

export default function() {
    return {
        orders: [],
        page: 1,
        totalPages: 0,
        perPage: 15,
        orderColumn: null,
        orderDirection: null,
        search: {
            'trip.startTime[after]': null,
            'trip.startTime[before]': null,
            'id': null,
            'trip.agency.name': null,
            'user.name': null,
            'user.phone': null,
        },
        searchParams: {
            agencyName: null,
            status: null,
            requestNumber: null,
            name: null,
            phone: null,
        },
        places: [],
        apiUrl: process.env.VUE_APP_API_URL,
        orderStatuses,
        availableStatus: [
            {
                label: 'Processando',
                value: 1
            },
            {
                label: 'Autorizado',
                value: 2
            },
            {
                label: 'Pago',
                value: 3
            },
            {
                label: 'Reembolsado',
                value: 4
            },
            {
                label: 'Aguardando pagamento',
                value: 5
            },
            {
                label: 'Reembolso pendente',
                value: 6
            },
            {
                label: 'Negado',
                value: 7
            },
            {
                label: 'Cancelado',
                value: 8
            },
            {
                label: 'Não pago',
                value: 9
            },
            {
                label: 'Aguardando pagamento pix',
                value: 11
            },
            {
                label: 'Todos',
                value: null
            }
        ],
        fields: [
            {
                key: 'id',
                label: 'Pedido',
                sorter: false
            },
            {
                key: 'agencyName',
                label: 'Agência',
                sorter: false
            },
            {
                key: 'destination',
                label: 'Destino',
                sorter: false
            },
            {
                key: 'buyerName',
                label: 'Comprador',
                sorter: false
            },
            {
                key: 'buyerPhone',
                label: 'Telefone',
                sorter: false
            },
            {
                key: 'status',
                label: 'Status',
                sorter: false
            },
            {
                key: 'timestamp',
                label: 'Data do pedido'
            },
            {
                key: 'duration',
                label: 'Data da trip'
            },
            {
                key: 'actions',
                label: 'Detalhes',
                sorter: false
            }
        ]
    }
}
